import { render, staticRenderFns } from "./PerfectData.vue?vue&type=template&id=12aa20c8&scoped=true&"
import script from "./PerfectData.vue?vue&type=script&lang=js&"
export * from "./PerfectData.vue?vue&type=script&lang=js&"
import style0 from "./PerfectData.vue?vue&type=style&index=0&id=12aa20c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12aa20c8",
  null
  
)

export default component.exports